import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "region-config",
    templateUrl: "./region-config.view.html",
    providers: []
})
export class RegionConfigView implements OnInit {
    baseUrl = "";
    regionConfig: any = {
        margin: "5px",
        padding: "5px",
        background: "#E6E6E6",
        corner: "10px 0 0 0"
    };

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        this.baseUrl = sharedService.sessionUrl;
        if (this.activatedRoute.parent.routeConfig.path == "speaker-sessions") {
            this.regionConfig = this.sharedService.sessionLayoutConfig.catalogConfig[
                this.sharedService.expansionStyle
            ].regionConfig;
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.regionConfig = this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].regionConfig;
        }
    }

    ngOnInit() {}
}
